import { backofficeDialogOptions } from 'src/app/layout/shared/dialogs/backoffice-dialog.options';

import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DynamicConfirmModalComponent } from 'src/app/layout/shared/dynamic-confirm-modal/dynamic-confirm-modal.component';
import { AccountSettingsService } from './account-settings.service';

@Injectable({
  providedIn: 'root'
})
export class EmailVerificationService {

  constructor(private accountService: AccountSettingsService, private modalService: NgbModal, private translate: TranslateService) { }

  resendVerificationEmail() {
    this.accountService.resendVelidationEmail().subscribe((res) => {
      const modalRef = this.modalService.open(DynamicConfirmModalComponent, backofficeDialogOptions('product-confirm', 'standard'));
  modalRef.componentInstance.modalTitle = this.translate.instant('auth_validation_email_sent_title');
  modalRef.componentInstance.modalText = this.translate.instant('auth_validation_email_sent_text');
      modalRef.componentInstance.modalClass = "info";
      modalRef.componentInstance.allButtons = false;

      modalRef.result.then((result) => {
      }, (reason) => {
      });

    },
      (error) => {
        const rawDetail = error?.error?.detail || '';
        const waitRegex = /must wait at least (\d+) minutes?/i;
        let translatedDetail = rawDetail;
        const match = rawDetail.match(waitRegex);
        if(match){
          const mins = match[1];
            translatedDetail = this.translate.instant('auth_wait_minutes', { value: mins });
        }
        const modalRef = this.modalService.open(DynamicConfirmModalComponent, backofficeDialogOptions('product-confirm', 'standard'));
        modalRef.componentInstance.modalTitle = translatedDetail;
        modalRef.componentInstance.modalText = translatedDetail;
        modalRef.componentInstance.modalClass = "warning";
        modalRef.componentInstance.allButtons = false;
        modalRef.result.then((result) => {});
      })
  }
}
